module.exports = __webpack_public_path__ + "static/media/promo-photo-overlay.55e45847.png";